<app-report-header
  class="d-none d-print-block"
  [routeName]="route.name"
></app-report-header>

<app-report-summary
  class="d-none d-print-block mt-3"
  [route]="route"
></app-report-summary>

<h4 class="d-none d-print-block">Road Type Distance Report</h4>
<div class="scroll-modal">
  <table class="roadTable table" id="road-type-table">
    <thead class="bg-gray-light">
      <tr>
        <th class="border-top-0">Stop</th>
        <th class="border-top-0 text-right">
          Leg {{ distanceUnits | reportsDistanceUnit }}
        </th>
        <th class="border-top-0 text-right">Interstate</th>
        <th class="border-top-0 text-right">Interstate (No Ramps)</th>
        <th class="border-top-0 text-right">Divided</th>
        <th class="border-top-0 text-right">Primary</th>
        <th class="border-top-0 text-right">Secondary</th>
        <th class="border-top-0 text-right">Ferry</th>
        <th class="border-top-0 text-right">Ramp</th>
        <th class="border-top-0 text-right">Local</th>
        <th class="border-top-0 text-right">Toll Road</th>
      </tr>
    </thead>
    <tbody>
      <ng-container
        *ngFor="let reportLine of roadTypeReportLines; let k = index"
      >
        <tr
          [ngClass]="{
            'bg-gray-light': !reportLine?.Stop,
            'font-weight-bold': !reportLine?.Stop
          }"
        >
          <td *ngIf="reportLine.Stop !== null">
            <app-report-stop
              [stop]="reportLine.StopDisplay"
              [routeColor]="route.color"
              [stopText]="reportLine.routeAddress"
            ></app-report-stop>
          </td>
          <td class="text-right" *ngIf="reportLine.Stop === null">TOTAL</td>
          <td class="text-right">
            {{ reportLine.LMiles | precision : precision }}
          </td>
          <td class="text-right">
            {{ reportLine.InterSt | number : "1.1-1" }}
          </td>
          <td class="text-right">
            {{ reportLine.InterstNoRamp | number : "1.1-1" }}
          </td>
          <td class="text-right">
            {{ reportLine.Divide | number : "1.1-1" }}
          </td>
          <td class="text-right">
            {{ reportLine.Prime | number : "1.1-1" }}
          </td>
          <td class="text-right">
            {{ reportLine.Second | number : "1.1-1" }}
          </td>
          <td class="text-right">
            {{ reportLine.Ferry | number : "1.1-1" }}
          </td>
          <td class="text-right">
            {{ reportLine.Ramp | number : "1.1-1" }}
          </td>
          <td class="text-right">
            {{ reportLine.Local | number : "1.1-1" }}
          </td>
          <td class="text-right">
            {{ reportLine.Toll | number : "1.1-1" }}
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>

  <div class="disclaimer p-2" id="road-type-disclaimer" style="font-size: 12px">
    <span class="text-muted">{{
      route?.roadTypeReport?.Disclaimers?.join()
    }}</span>
    <span class="text-muted" *ngIf="!roadTypeReportLines"
      >This report does not reflect total mileage per route. If you are looking
      for a comprehensive report with mileage totals, please view the Detailed
      Route Report.</span
    >
  </div>
  <app-show-data-version [route]="route"></app-show-data-version>
</div>
